import { UwtSupplierType, UwtType } from './LeasingCalculatorCodes';

export enum LeasingObjectAgeCode {
  NEW = 'Novo',
  USED = 'Rabljeno',
}
export const NOT_REGISTERED = 'Nije registrirano';

export interface LeasingInfoCalculatorData {
  infoInterestRate?: string | number;
  adminCostPercentage?: string | number;
  adminCostAmount?: string | number;
  financialAdminCostPercentage?: string | number;
  operationalAdminCostPercentage?: string | number;
}

export interface LeasingCalculatorGeneralData {
  leasingRecipientType?: UwtType;
  leasingType?: UwtType;
  leasingObjectSupplier?: UwtSupplierType;
  leasingCurrency?: UwtType;
}

export interface LeasingCalculatorObjectData {
  leasingObjectType?: UwtType;
  leasingObject?: UwtType;
  leasingObjectMake?: UwtType;
  leasingObjectModel?: UwtType;
  leasingObjectFuel?: UwtType;
  leasingObjectEngine?: UwtType;
  leasingObjectFirstRegistrationYear?: UwtType;
  currentNumberOfKilometersTraveledOrWorkingHours?: string;
  averageTotalMileage?: UwtType;
}

export interface LeasingCalculatorFinancialData {
  leasingObjectPrice?: string;
  leasingNetObjectPrice?: string;
  leasingTaxRate?: UwtType;
  leasingObjectPpmv?: string;
  financingAmount?: string;
  participationAmount?: number;
  financialLeasingParticipation?: number;
  operationalLeasingParticipation?: number;
  leasingPaymentPeriodType?: UwtType;
  financingPeriod?: UwtType;
  leftoverPercentage?: string;
  financialLeasingInstallment?: string;
  financialParticipationAmount?: string;
  financialFutureValuePercentage?: string;
  financialFutureValue?: string;
}

export interface LeasingCalculatorOperationalData {
  remainingValuePercentage?: string;
  operationalLeasingInstallment?: string;
  operationalParticipationAmount?: string;
  operationalFutureValuePercentage?: string;
  operationalFutureValue?: string;
}

export interface LeasingPremadeProduct {
  productId: number;
  productName: string;
  minimumRepurchaseValue?: number;
  interestRateType?: UwtType;
  referentInterestRate?: UwtType;
  margin?: number;
  interestRate?: number;
  cost?: number;
  currency?: UwtType;
  remainingAmountYear1?: number;
  remainingAmountYear2?: number;
  remainingAmountYear3?: number;
  remainingAmountYear4?: number;
  remainingAmountYear5?: number;
}

export interface LeasingCalculatorProductSelectionData {
  leasingType?: number;
  client?: {
    gemicroId?: string;
    lesseeTypeId?: number;
  };
  transaction?: {
    productId?: number;
    leasingTypeId?: number;
    financingDuration?: number;
    participationPercentage?: number;
    redemptionValuePercentage?: number;
    leasingObjectAmount?: number;
    leasingObjectMakeId?: number;
    leasingObjectModelId?: number;
    leasingObjectTypeId?: number;
    ppmvAmount?: number;
    leasingObjectAmountWithoutTaxes?: number;
    leasingObjectCatalogAmount?: number;
    leasingObjectId?: number;
    fuelTypeId?: number;
    engine?: string;
    supplier?: string;
    productionDate?: Date;
    milage?: number;
    allowedUsageLevel?: string;
    ageId?: number;
    currency?: string;
    interestRateTypeId?: number;
    interestRateType?: string;
    referentInterestRateId?: number;
    paymentPeriodId?: number;
    remainingValuePercentage?: string;
  };
}
